export enum OpportunityAndRisk {
  ALL = 'All',
  LOW = 'LOW',
  MEDIUM_HIGH = 'MEDIUM_HIGH',
  MEDIUM_LOW = 'MEDIUM_LOW',
  HIGH = 'HIGH',
}
